<span
    *ngIf="menuItemList.items.length > 0"
    mat-icon-button
    [matMenuTriggerFor]="menu"
    stopPropagation
    menuSelectionBackground
>
    <mat-icon class="menu-icon-triggerer" svgIcon="aumico-pattern-icon-settings-vertical"></mat-icon>
</span>
<mat-menu #menu="matMenu" class="mapping-menu" [hasBackdrop]="true">
    <button
        *ngFor="let item of menuItemList.items"
        class="menu-item"
        mat-menu-item
        [disabled]="item.disabled"
        [id]="item.action"
        [editCell]="cellComponent"
        [class.disabled]="item.disabled"
        (click)="onMenuItemClick(item.action)"
    >
        <mat-icon
            [id]="item.action"
            [class.disabled]="item.disabled"
            *ngIf="item.icon"
            [svgIcon]="item.icon"
        ></mat-icon>
        <span>{{ item.caption | i18next }}</span>
    </button>
</mat-menu>
